import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { notification } from 'antd';
import { usePost } from 'hooks';
import { exportTemplatesBulkDelete } from 'services/api';
import { exportTemplateActions as actions } from 'reducers/exportTemplate/reducer';
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { errorResToMessageArray } from './errorResToMessageArray';

/**
 * @param {() => void} [_onRequestSuccess]
 * @param {() => void} [_onRequestError]
 */
export const useBulkDeleteTemplateMutation = (
  _onRequestSuccess,
  _onRequestError
) => {
  const dispatch = useDispatch();

  const onRequestError = useCallback(
    res => {
      notification.open({
        icon: <CloseCircleOutlined style={{ fontSize: 20, color: 'red' }} />,
        message: 'Error',
        description: (
          <div>
            Failed to delete templates.
            {errorResToMessageArray(res).map(err => (
              <p key={err} style={{ fontSize: 12, color: '#666' }}>
                {err}
              </p>
            ))}
          </div>
        ),
        placement: 'bottomLeft',
        duration: 8,
      });
      _onRequestError?.();
    },
    [_onRequestError]
  );

  const onRequestSuccess = useCallback(() => {
    dispatch(actions.serverMutationOccurred());
    notification.open({
      icon: <CheckCircleOutlined style={{ fontSize: 20, color: 'green' }} />,
      message: 'Success',
      description: 'Templates deleted successfully',
      placement: 'bottomLeft',
    });
    _onRequestSuccess?.();
  }, [_onRequestSuccess, dispatch]);

  const [{ loading: bulkDeleteLoading }, postBulkDelete] = usePost({
    onMount: false,
    configuration: {
      onRequestSuccess,
      onRequestError,
    },
  });

  /** @param {number[]} ids */
  const triggerBulkDelete = useCallback(
    ids => {
      postBulkDelete({
        url: exportTemplatesBulkDelete,
        body: { ids },
      });
    },
    [postBulkDelete]
  );

  return {
    triggerBulkDelete,
    bulkDeleteLoading,
  };
};
